import { render, staticRenderFns } from "./ProjectsForecast.vue?vue&type=template&id=7f31813c&"
import script from "./ProjectsForecast.vue?vue&type=script&lang=ts&"
export * from "./ProjectsForecast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports